import BaseModel from './BaseModel';

export default class QrMenuDesk extends BaseModel {
   getId() {
      return this.get('id');
   }
}
